import { useEffect, useRef } from "react";
export function useOnChange(cb, deps) {
    var ref = useRef({ firstCall: true });
    useEffect(function () {
        if (ref.current.firstCall) {
            ref.current.firstCall = false;
            return;
        }
        return cb();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
